import React from 'react';
import {useSelector} from 'react-redux';
import LegalDocumentPage from '../LegalDocumentPage/LegalDocumentPage';
import {CONTACTS_CONTENT} from '../../../configs/contacts';

function ContactsPage({onBack}) {
  const playerName = useSelector((state) => state.private.auth.name);
  const playerId = useSelector((state) => state.private.auth.id);

  const content = {
    ...CONTACTS_CONTENT,
    blocks: CONTACTS_CONTENT.blocks.map((block) => {
      if (block.type !== 'emailLink') {
        return block;
      }
      const subject = `Обращение от ${playerName}`;
      const body = `<Опишите свой вопрос тут>\n-----\nОбращение от пользователя ${playerName} (id: ${playerId})`;
      const mailtoHref = `mailto:${block.email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
      return {...block, mailtoHref};
    }),
  };

  return (
    <LegalDocumentPage
      pageId="ContactsPage"
      content={content}
      onBack={onBack}
    />
  );
}

export default ContactsPage;
